export default "__VITE_ASSET__BFb5VDhz__"